import { render } from "./ATASummaryReport.vue?vue&type=template&id=a7d64132"
import script from "./ATASummaryReport.vue?vue&type=script&lang=js"
export * from "./ATASummaryReport.vue?vue&type=script&lang=js"

import "./ATASummaryReport.vue?vue&type=style&index=0&id=a7d64132&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__